<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <!-- <div class="col-md-12 col-12-12 col-lg-12">   
        <div class="mt-0">
          <a href="#" class="footer-logo">
            <img src="logo.png" alt="">
          </a>
        </div>
      </div> -->
     <div class="col-md-12 col-xs-12">
       <ul class="footer-links">
         <li>
            <a routerLink="/home" href="#" aria-label="Anchor">
              Home
            </a>
         </li>
         <li>
          <a routerLink="/aboutus" href="#" aria-label="Anchor">
            About Us
          </a>
        </li>
        <!-- <li>
          <a routerLink="/buyer">
            Buyer
          </a>
        </li>
        <li>
          <a href="#">
            Seller
          </a>
        </li>
        <li>
          <a routerLink="/enterprise">
            Enterprise
          </a>
        </li> -->
        <li>
          <a routerLink="/contactus" href="#" aria-label="Anchor">
            Contact
          </a>
        </li>
        <li>
          <a routerLink="/faq" href="#" aria-label="Anchor">
            Faq
          </a>
        </li>
        <li>
          <a routerLink="/whygovttowauctions" href="#" aria-label="Anchor">
            Why GovTow Auctions
          </a>
        </li>
        <li>
          <a routerLink="/tnc" href="#" aria-label="Anchor">
            Terms of Use
          </a>
        </li>
        <li>
          <a routerLink="/privacypolicy" href="#" aria-label="Anchor">
            Privacy Policy
          </a>
        </li>
       </ul>
     </div>
      <!-- <div class="col-xs-12 col-lg-7 col-xl-8">
        
        <div class="row">
          <div class="col-xs-12 col-md-4 col-xl-4">
            <ul class="footer-links">
              <li>
                
              </li>
             
            </ul>
          </div>
        </div>
      </div> -->
          <!-- <div class="col-xs-12 col-md-4 col-xl-4">
            <ul class="footer-links"> -->
              
              <!-- <li>
                <a routerLink="/seller">
                  Seller
                </a>
              </li> -->
<!--               
            </ul>
          </div> -->
         
        
      <!-- <div class="col-xs-12 col-lg-5 col-xl-4">
        
        <div class="row">
          <div class="col-md-12 col-12-12 col-lg-12">
            
            <div class="mt-0">
              <a href="#" class="footer-logo">
                <img src="logo.png" alt="">
              </a>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
  <div class="footer-disclaimer">
    <div class="container-fluid">
      <div class="footer-disclaimer__inner">
        <div class="footer-disclaimer__copyright">
          <p>© 2021 GovTow Auctions. All Rights Reserved </p>
        </div>
      </div>
    </div>
  </div>
</footer>